import { match } from "ts-pattern";

import { IncidentWorkItemStatusSchema } from "@thalamos/common";
import type { IncidentWorkItemWithContext } from "@thalamos/vision-common";
import {
  calculateIncidentWorkItemStatus,
  FormSectionSchema,
  IncidentFormTypeSchema,
} from "@thalamos/vision-common";

export function calculateDerivedIncidentStatus(
  incidentWorkItem: IncidentWorkItemWithContext,
): string {
  // TODO: more complex logic here around status of arrival/handover etc.
  // Maybe this logic happens on the server side?
  return match(
    calculateIncidentWorkItemStatus(incidentWorkItem).unwrapOr(
      IncidentWorkItemStatusSchema.enum.unknown,
    ),
  )
    .with("unknown", () => "formStatusUnknown")
    .with("arrived-at-place-of-safety", () => "arrivedAtPlaceOfSafety")
    .with("awaiting-arrival", () => "awaitingArrival")
    .with("form-shared", () => "formShared")
    .with("nhs-form-accepted", () => "formAccessed")
    .with("police-presence-requested", () => "policePresenceRequested")
    .with("police-presence-not-requested", () => "policePresenceNotRequested")
    .with("ended", () => {
      const preEndIncidentForm = incidentWorkItem.forms.find(
        (form) => form.formType === IncidentFormTypeSchema.enum.preEndIncident,
      );

      if (preEndIncidentForm) {
        const preEndIncidentSections = preEndIncidentForm.sections?.find(
          (section) => section.id === FormSectionSchema.enum.preEndIncident,
        );

        if (
          preEndIncidentSections?.data?.endingReason ===
          "auto-close-by-anonymiser-job"
        ) {
          return "formAutoClosed";
        }
      }

      return "formEnded";
    })
    .with("in-progress", () => "formInProgress")
    .exhaustive();
}
